
import React from 'react';
import { createPortal } from 'react-dom';
import { CustomSelectContext } from './CustomSelectContext';

interface CustomSelectContentProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
  triggerRef?: React.RefObject<HTMLButtonElement>;
}

export const CustomSelectContent: React.FC<CustomSelectContentProps> = ({
  children,
  style,
  onClick,
  triggerRef
}) => {
  const { isOpen } = React.useContext(CustomSelectContext);
  const [position, setPosition] = React.useState({ top: 0, left: 0, width: 0 });

  React.useEffect(() => {
    if (isOpen && triggerRef?.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 4, // 4px gap
        left: rect.left + window.scrollX,
        width: Math.max(rect.width, 150) // Minimum width of 150px
      });
    }
  }, [isOpen, triggerRef]);

  if (!isOpen) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.(e);
  };

  const dropdownContent = (
    <div 
      data-portal="dropdown"
      className="fixed bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 shadow-2xl rounded-md max-h-96 overflow-y-auto"
      style={{ 
        top: position.top,
        left: position.left,
        minWidth: position.width,
        width: 'auto', // Allow width to expand as needed
        maxWidth: '200px', // Prevent excessive width
        zIndex: 999999,
        position: 'fixed',
        pointerEvents: 'auto',
        isolation: 'isolate',
        ...style
      }}
      onClick={handleClick}
    >
      {children}
    </div>
  );

  return createPortal(dropdownContent, document.body);
};
